"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextWithHtml = void 0;
var _mui = require("@ori-ui/mui");
var _TextWithHtml = require("../TextWithHtml");
const StyledTextWithHtml = exports.StyledTextWithHtml = (0, _mui.styled)(_TextWithHtml.TextWithHtml)(({
  theme
}) => ({
  maxWidth: 600,
  margin: 'auto',
  color: theme.palette.text.primary,
  [`.${_TextWithHtml.textWithHtmlClasses.text}`]: {
    WebkitLineClamp: 6,
    [theme.breakpoints.up('sm')]: {
      WebkitLineClamp: 4
    }
  }
}));
//# sourceMappingURL=styles.js.map